import type { QueryStatus } from '@tanstack/react-query'

type ScreenDataStatus = 'loading' | 'error' | 'ready'

const isQueryPending = (status: QueryStatus) => status === 'pending'

const isPrivacyCenterContentLoading = (isAppLoading: boolean, hasRequiredContent: boolean) =>
  isAppLoading && !hasRequiredContent

const resolveRemoteDataScreenStatus = ({
  queryStatus,
  isQueryError,
  hasRequiredData,
  isContentLoading,
}: {
  queryStatus: QueryStatus
  isQueryError: boolean
  hasRequiredData: boolean
  isContentLoading: boolean
}): ScreenDataStatus => {
  if (isContentLoading || isQueryPending(queryStatus)) return 'loading'
  if (isQueryError || !hasRequiredData) return 'error'
  return 'ready'
}

export type { ScreenDataStatus }
export { isQueryPending, isPrivacyCenterContentLoading, resolveRemoteDataScreenStatus }
